import React from 'react';
import { Typography, Grid, Icon, InputBase, TextField, MenuItem, Card,
		 CardActionArea, CardMedia, CardContent } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import LoadBox from '../../components/LazyBox';

//services
import EventoAPI from '../../../services/api/Evento';

//css
import './eventos.css';


export default class Eventos extends React.Component {
	state = {
		eventos: [],
		eventos_filtrados:[],
		filtro_status: 0,

		loading:true,
	}
	refreshEventos = () => {
		EventoAPI.lista_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ eventos: SetStatus(res), loading: false })
				return;
			})
		});
	}

	filterStatus = (string) => {
		const { eventos } = this.state;
		const search = eventos.filter( evento => evento.status.sigla === string);
		if( string !== 0 ){
			this.setState({ eventos_filtrados: search, filtro_status: string })
		}else{
			this.setState({ eventos_filtrados: [], filtro_status: string })
		}
	}

	filter = (string) => {
		const { eventos } = this.state;
		let busca = string.toLowerCase();
		const search = eventos.filter( evento => evento.titulo.toLowerCase().indexOf(busca) !== -1);
		this.setState({ eventos_filtrados: search })
	}

	componentDidMount(){
		this.refreshEventos();
	}
    render() {
		const { eventos, loading, eventos_filtrados, filtro_status } = this.state;
		const lista_eventos = eventos_filtrados.length > 0 ? eventos_filtrados : eventos;
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>Eventos</title>
						<meta name="description" content="Helmet application" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Eventos</Typography>
						</div>
					</div>
					<div className="app_content_page__row" >
						<LoadBox loading={loading} height="50vh" >
							<Grid container spacing={16} >
								<Grid item md={9} xs={12} >
									<div className="eventos_barsearch" >
										<Icon>search</Icon>
										<InputBase placeholder="Digite o nome do evento.."
												   onChange={(e) => this.filter(e.target.value)}
												   fullWidth />
									</div>
								</Grid>
								<Grid item md={3} xs={12} >
									<TextField
										select
										style={{backgroundColor:'#FFF'}}
										label="Status"
										fullWidth
										onChange={(e) => this.filterStatus(e.target.value)}
										value={filtro_status}
										variant="outlined"
									>
										<MenuItem value={0}>
											Todos
										</MenuItem>
										<MenuItem value="ea">Em andamento</MenuItem>
										<MenuItem value="eb">Em breve</MenuItem>
										<MenuItem value="f">Finalizado</MenuItem>
									</TextField>
								</Grid>
								<Grid item md={12} >
									<Grid container spacing={16} className="grid_list_evnetos"  >
										{lista_eventos.map((e,k) => <Grid key={k} item md={3} xs={12} >
											<Card className="card_transparent" >
												<CardActionArea component={Link} to={`/eventos/${e.id}`} >
													<CardMedia
													image={e.img}
													title={e.titulo}
													className="image"
													/>
													<CardContent>
														<Typography gutterBottom variant="h5" component="h2">
															{e.titulo}
														</Typography>
														<Typography variant="body2" color="textSecondary" component="p">
															{e.descricao.replace(/<(.|\n)*?>/g, '').substring(0, 120)}
														</Typography>
														<Typography variant="body2" color="textSecondary" component="p">
															<Icon>calendar_today</Icon> {moment(e.data_inicio).format('DD/MM/YYYY')} à {moment(e.data_fim).format('DD/MM/YYYY')}
														</Typography>
														<p className={`status_process ${e.status.class}`} >
															{e.status.text}
														</p>
													</CardContent>
												</CardActionArea>
											</Card>
										</Grid>)}
									</Grid>
								</Grid>
							</Grid>
						</LoadBox>
					</div>
				</div>
        );
    }
}


function TextStatus(inicio,fim){
	const hoje = moment().format('YYYY-MM-DD');
	const acabar = moment(hoje).diff(fim,'days');
	const comecar = moment(hoje).diff(inicio,'days')
	//LOGICA
	// comecar >= 0 && acabar =< 0 ===> Em andamento
	// comecar =< -1 && acabar =< -1 ===> Em breve
	// comecar >= 1 && acabar >= 1 ===> Finalizado
	let rs = {
		class: null,
		text: null,
		sigla: null,
	}
	if( comecar >= 0 && acabar <= 0 ){
		rs.class = 'em_andamento';
		rs.text = 'Em andamento';
		rs.sigla = 'ea';
	}
	if( comecar <= -1 && acabar <= -1 ){
		rs.class = 'em_breve';
		rs.text = 'Em breve';
		rs.sigla = 'eb';
	}
	if( comecar >= 1 && acabar >= 1 ){
		rs.class = 'finalizado';
		rs.text = 'Finalizado';
		rs.sigla = 'f';
	}

	return rs;
}

function SetStatus(eventos){
	let rs = [];
	for( let ev of eventos ){
		ev.status = TextStatus(ev.data_inicio,ev.data_fim);
		rs.push(ev);
	}
	return rs;
}



// WEBPACK FOOTER //
// ./src/web/pages/eventos/index.js